import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#36B43B\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#success_svg__a)\"><path d=\"m6.375 13.147 2.297 3.26a.984.984 0 0 0 1.6.047l7.353-9.303\"></path><path d=\"M1.453 11.999a10.546 10.546 0 1 0 21.093 0 10.546 10.546 0 0 0-21.093 0\"></path></g><defs><clipPath id=\"success_svg__a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }